import { APIConstants } from '../../constants/api';

export const BifrostApiErrorInterceptorList = [
  APIConstants.AUTH.GET_USER_BY_CODE,
  APIConstants.AUTH.VERIFY,
  APIConstants.AUTH.LOGIN,
  APIConstants.AUTH.FORGOT_PASSWORD,
  APIConstants.AUTH.RESET_PASSWORD,
  APIConstants.AUTH.SEND_OTP,
  APIConstants.AUTH.LOGOUT,
  APIConstants.AUTH.REQUEST_ACCESS,
];
